import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAdd = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "1 1 20 21",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.664 4.043 C 10.491 4.148,10.395 4.272,10.344 4.456 C 10.316 4.557,10.304 5.552,10.304 7.709 L 10.303 10.817 7.143 10.817 C 3.998 10.817,3.982 10.817,3.822 10.894 C 3.326 11.135,3.330 11.877,3.829 12.104 C 3.971 12.168,4.142 12.172,7.140 12.173 L 10.301 12.173 10.312 15.373 L 10.322 18.572 10.407 18.709 C 10.734 19.235,11.528 19.114,11.656 18.519 C 11.684 18.389,11.697 17.361,11.697 15.252 L 11.697 12.173 14.859 12.173 C 17.858 12.172,18.029 12.168,18.171 12.104 C 18.670 11.877,18.674 11.135,18.178 10.894 C 18.018 10.817,18.002 10.817,14.857 10.817 L 11.697 10.817 11.696 7.728 C 11.695 5.778,11.681 4.579,11.658 4.477 C 11.613 4.283,11.517 4.153,11.336 4.043 C 11.151 3.929,10.849 3.929,10.664 4.043 ",
		stroke: "none",
		fillRule: "evenodd",
		fill: "currentColor"
	})
});
export default SvgAdd;
